import { render, staticRenderFns } from "./yitiji2.vue?vue&type=template&id=a1138490&scoped=true"
var script = {}
import style0 from "./yitiji2.vue?vue&type=style&index=0&id=a1138490&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1138490",
  null
  
)

export default component.exports